import { render, staticRenderFns } from "./totaloutstock-history.vue?vue&type=template&id=c4a13fa6&"
import script from "./totaloutstock-history.vue?vue&type=script&lang=ts&"
export * from "./totaloutstock-history.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports